import API from '~config/api';
import {
  ApiPromise,
  PaginationRequestParams,
  DataResponse,
  DataPaginateResponse,
  ErrorResponse,
} from '~globals/types/api';
import { RouteStateTypes } from '~globals/types/enums';

import { ApiTransactionExtendedGenerateRoute } from '../apiTransaction/types';
import { Route, RouteStats } from '../route/types';

import {
  TemplateRoute,
  TemplateRouteCreateBody,
  TemplateRouteFilter,
  TemplateRouteCreateByRouteBody,
  TemplateRouteUpdateNameBody,
} from './types';

const TEMPLATE_ROUTE_ENPOINTS = {
  getTemplateRoutes: '/api/v1/Route/Route/TemplateRoute',
  generateTemplateRoute: '/api/v1/Route/route/generate',
  searchTemplateRoutes: '/api/v1/Route/route/search',
  createTemplateByRoute: '/api/v1/Route/Route/CreateRouteTemplate',
  updateTemplateName: '/api/v1/Route/Route/UpdateRouteTemplateName',
};

export const getTemplateRoutes = (): ApiPromise<
  DataResponse<TemplateRoute[]>,
  ErrorResponse
> =>
  API.get<DataResponse<TemplateRoute[]>, ErrorResponse>(
    TEMPLATE_ROUTE_ENPOINTS.getTemplateRoutes,
  );

export const generateTemplateRoute = (
  body: TemplateRouteCreateBody,
): ApiPromise<
  DataResponse<ApiTransactionExtendedGenerateRoute>,
  ErrorResponse
> =>
  API.post<DataResponse<ApiTransactionExtendedGenerateRoute>, ErrorResponse>(
    TEMPLATE_ROUTE_ENPOINTS.generateTemplateRoute,
    { ...body, isTemplate: true },
  );

export const searchTemplateRoutes = ({
  pagination: { page, sizePerPage },
  filters,
}: PaginationRequestParams<TemplateRouteFilter>): ApiPromise<
  DataPaginateResponse<Route[], RouteStats>,
  ErrorResponse
> => {
  const routeCode = filters?.templateCode ?? null;
  const driversId = filters?.driverId ? [filters.driverId] : null;
  const vehiclesId = filters?.vehicleId ? [filters.vehicleId] : null;

  return API.post<DataPaginateResponse<Route[], RouteStats>, ErrorResponse>(
    TEMPLATE_ROUTE_ENPOINTS.searchTemplateRoutes,
    {
      dateFrom: null,
      dateTo: null,
      routeCode,
      driversId,
      vehiclesId,
      routeStateTypesId: [
        RouteStateTypes.New,
        RouteStateTypes.Assigned,
        RouteStateTypes.Approve,
        RouteStateTypes.Rejected,
        RouteStateTypes.InProgress,
        RouteStateTypes.Finalized,
        RouteStateTypes.Expired,
      ],
      includeApiTransaction: false,
      templateRoutes: true,
      pagination: {
        offset: page,
        size: sizePerPage,
      },
    },
  );
};

export const createTemplateByRoute = (
  body: TemplateRouteCreateByRouteBody,
): ApiPromise<DataResponse<TemplateRoute>, ErrorResponse> =>
  API.post<DataResponse<TemplateRoute>, ErrorResponse>(
    TEMPLATE_ROUTE_ENPOINTS.createTemplateByRoute,
    body,
  );

export const updateTemplateName = (
  body: TemplateRouteUpdateNameBody,
): ApiPromise<DataResponse<null>, ErrorResponse> =>
  API.put<DataResponse<null>, ErrorResponse>(
    TEMPLATE_ROUTE_ENPOINTS.updateTemplateName,
    body,
  );
